
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/job/[ref]",
      function () {
        return require("private-next-pages/account/job/[ref].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/job/[ref]"])
      });
    }
  